/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
import { IncDecField, InlineMessage } from '@insticator/insticator-ui'


// styles
import injectSheet from 'react-jss'
import styles from './placements_styles'
import Space from 'material/space/space';
import ToggleButton from 'material/togglebutton/togglebutton';


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : MEDIA COMMENTS ~~~~~~~~~~ ========== */
const Placements = injectSheet(styles)((props) => {

  const {  
    showBeforeUnit,
    showOnFirstSlot,
    showInBetweenArticles,
    adsCountBetweenArticles,
    loadMoreStyle,
    enableSpotlight,
    showAfterUnit, 
    version, 
    selectVersion, 
    visibility,
    onChange 
  } = props

  const placementVersion = [
    {label: 'Desktop', value: 'desktop'},
    {label: 'Mobile', value: 'mobile'}
  ]

  return (
    <Space justifyContent={'space-between'} klass={`placements ${props.classes.placements}`} >
    <SectionGroupV2 
      title={'Placements'} 
      description={'Enable where each ad can display within the trending now unit.'}
      indented  
      disabled={visibility === 'NONE'}
    >
      <Space gap={16} direction={'column'}>
      <ToggleButton selected={version} items={placementVersion} onChange={item => selectVersion(item.value)} />
      <Space gap={16} direction={'column'} klass={visibility === 'NONE' ? 'disabled' : ''}>
      <ConfigToggle 
        title={'Before trending now unit'}
        checked={showBeforeUnit}
        onChange={val => onChange('showBeforeUnit', val)}
      />
      <ConfigToggle 
        title={'1st slot'}
        checked={showOnFirstSlot}
        onChange={val => onChange('showOnFirstSlot', val)}
        gap={16}
      />
      {loadMoreStyle === 'BUTTON' && (
        <ConfigToggle 
          title={'After row(s)'}
          checked={showInBetweenArticles}
          onChange={val => onChange('showInBetweenArticles', val)}
          gap={16}
        >
          <IncDecField
            name={'inbetweenrootcommentscount'}
            defaultValue={adsCountBetweenArticles}
            minValue={2}
            maxValue={25}
            handleIncToggle={val => onChange('adsCountBetweenArticles', val)}
            handleDecToggle={val => onChange('adsCountBetweenArticles', val)}
            ctaPosition={'inline'}
            disabled={!showInBetweenArticles}
          />
        </ConfigToggle>
      )}
      <ConfigToggle 
        title={'After trending now unit'}
        checked={showAfterUnit}
        onChange={val => onChange('showAfterUnit', val)}
        gap={16}
      />
      <InlineMessage
        key={'meow'}
        display={true}
        name={'headercode'}
        variant={'neutral'}
        icon={'exclamation-triangle'}
        title={null}
        message={<span>This preview reflects your selected display type and featured article in General {'>'} Article Layout</span>}
        close={false}
        handleClose={null}
      />
      </Space>
      </Space>
    </SectionGroupV2>
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Placements;